
import React, { useState, useEffect } from 'react';
import './menu.css'
import {
  HomeOutlined,
  ScheduleOutlined,
  TeamOutlined,
  VideoCameraOutlined ,
  StarOutlined,
  //InsertRowBelowOutlined,
  //DollarOutlined,
  FileDoneOutlined,
  FlagOutlined,
  UserOutlined,
  NotificationOutlined ,
  ApartmentOutlined,
  InfoCircleOutlined,
  ControlOutlined,
  SafetyOutlined,
  TrademarkOutlined,
  LikeOutlined,
  PictureOutlined,
  AppleOutlined ,
  QuestionCircleOutlined,
  LockOutlined ,
  UserAddOutlined,
  UserSwitchOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom'
import {setUser} from '../../redux/actions/AuthActions'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
import {Collapsed} from '../../redux/actions/MenuAction'

const { Sider } = Layout;
const { SubMenu } = Menu;

export const SiderMenu = ({isRTL,currentUser,setUser,ChangeLanguage,Collapsed,menu}) => {
  const [collapsed, setCollapsed] = useState(menu);
  const location = useLocation();
console.log(collapsed)
  // Similar to componentDidMount and componentDidUpdate:
  if(isRTL){
    allStrings.setLanguage('ar')
  }else{
    allStrings.setLanguage('en')
  } 
  

  useEffect(() => {
    if(isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
  });
  const onCollapse = (collapsed) =>{ setCollapsed(collapsed);Collapsed(collapsed);localStorage.setItem("@MENU",collapsed)};
  return (
    <Sider 
    style={{
      overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        //left:0
        left: isRTL?'auto':0,
        right: isRTL?0:'auto',
        direction:isRTL?'rtl':'ltr'
    }}
    collapsible collapsed={collapsed} onCollapse={onCollapse} >
      {!collapsed?
      <div className="logo" >
        <img alt="" style={{width: '90%',position: 'relative',top:isRTL?'-25px':'-25px',left:'0px'}} src={require('../../assets/images/logo-1.svg')} ></img>
        <p style={{letterSpacing:'6px',color:'#fff',fontSize:isRTL?'34px':'26px',fontStyle: 'oblique',
            fontWeight: '800',fontFamily: 'fantasy',display:'inline-block',marginLeft:isRTL?'10px':'0px',marginTop:isRTL?'-10px': 0}}></p>
      </div>
      :
      <div className="logo" >
        <img alt="" style={{width: '100%',position: 'relative',top: '2px',left:'0px'}} src={require('../../assets/images/logo-1.svg')} ></img>       
      </div>      
      }
      
      
      
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={[location.pathname]}
      >
        
         {/*Home */}
         {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Home">
              <HomeOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}} />
              <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.home}</span>
              <Link to="/Home"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('DASHBOARD')&&
            <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Home">
              <HomeOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-6px'}} />
              <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.home}</span>
              <Link to="/Home"></Link>
            </Menu.Item>
          }
        
        <SubMenu  key="sub2" style={{paddingLeft:isRTL?collapsed?0:35:0}} icon={<UserOutlined style={{
            float:isRTL? 'right':'none',
            position:isRTL?'absolute':'relative',
            right:isRTL?collapsed?28:16:collapsed?4:'auto',
            }} />} title={allStrings.allUsers}>
            {/*CLIENTS */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Users" > 
            <UserOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px'}}>{allStrings.users}</span>
              <Link to="/Users"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('CLIENTS')&&
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Users" > 
            <UserOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px'}}>{allStrings.users}</span>
              <Link to="/Users"></Link>
            </Menu.Item>
            }
            {/*WATING CLIENTS */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/WaitingUsers" > 
            <UserOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px'}}>{allStrings.waitingUsers}</span>
              <Link to="/WaitingUsers"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('CLIENTS')&&
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/WaitingUsers" > 
            <UserOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px'}}>{allStrings.waitingUsers}</span>
              <Link to="/WaitingUsers"></Link>
            </Menu.Item>
            }
            
            {/*SUB-ADMIN */}
            {currentUser.user.type ==="ADMIN" ?
            
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Supervisors" > 
            <UserSwitchOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}} />
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.supervisors}</span>
              <Link to="/Supervisors"></Link>
            </Menu.Item>
              :
              currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('SUB-ADMIN')&&
              
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Supervisors" > 
            <TeamOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}} />
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.supervisors}</span>
              <Link to="/Supervisors"></Link>
            </Menu.Item>
            }
          {currentUser.user.type ==="ADMIN" &&
          <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Admins" > 
          <TeamOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}} />
              <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.admin}</span>
            <Link to="/Admins"></Link>
          </Menu.Item>
          }{currentUser.user.type ==="ADMIN" &&
          <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/addUser" > 
          <UserAddOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
              <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.AddUser}</span>
            <Link to="/addUser"></Link>
          </Menu.Item>
          }
        </SubMenu>

        
        {/*occasionType */}
        {currentUser.user.type ==="ADMIN" ?
         <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/occasionType"> 
         <FileDoneOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
           <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.occasionType}</span>
           <Link to="/occasionType"></Link>
         </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('OCCASION-TYPE')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/occasionType"> 
        <FileDoneOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.occasionType}</span>
          <Link to="/occasionType"></Link>
        </Menu.Item>
        }
        {/*brands */}
        {currentUser.user.type ==="ADMIN" ?
         <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/brands"> 
         <TrademarkOutlined   style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
           <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.brands}</span>
           <Link to="/brands"></Link>
         </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('BRANDS')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/brands"> 
        <TrademarkOutlined   style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.brands}</span>
          <Link to="/brands"></Link>
        </Menu.Item>
        }
        {/*influencers */}
        {currentUser.user.type ==="ADMIN" ?
         <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/influencers"> 
         <VideoCameraOutlined    style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
           <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.influencers}</span>
           <Link to="/influencers"></Link>
         </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('INFLUENCERS')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/influencers"> 
        <VideoCameraOutlined    style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.influencers}</span>
          <Link to="/influencers"></Link>
        </Menu.Item>
        }
        {/*products */}
        {currentUser.user.type ==="ADMIN" ?
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/products"> 
        <AppleOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.products}</span>
          <Link to="/products"></Link>
        </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('PRODUCTS')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/products"> 
        <AppleOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.products}</span>
          <Link to="/products"></Link>
        </Menu.Item>
        }
        {/*REACTION */}
        {currentUser.user.type ==="ADMIN" ?
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Reactions"> 
        <LikeOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.reactions}</span>
          <Link to="/Reactions"></Link>
        </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('REACTION')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Reactions"> 
        <LikeOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.reactions}</span>
          <Link to="/Reactions"></Link>
        </Menu.Item>
        }
        {/*Interests */}
        {currentUser.user.type ==="ADMIN" ?
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Interests"> 
        <StarOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.interests}</span>
          <Link to="/Interests"></Link>
        </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('INTEREST')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Interests"> 
        <StarOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.interests}</span>
          <Link to="/Interests"></Link>
        </Menu.Item>
        }
        {/*posts */}
        {currentUser.user.type ==="ADMIN" ?
         <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/posts"> 
         <PictureOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
           <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.posts}</span>
           <Link to="/posts"></Link>
         </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('POSTS')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/posts"> 
        <PictureOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.posts}</span>
          <Link to="/posts"></Link>
        </Menu.Item>
        }
        {/*timeLine */}
        {currentUser.user.type ==="ADMIN" ?
         <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/timeLine"> 
         <PictureOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
           <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.timeLine}</span>
           <Link to="/timeLine"></Link>
         </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('POSTS')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/timeLine"> 
        <PictureOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.timeLine}</span>
          <Link to="/timeLine"></Link>
        </Menu.Item>
        }
        
        
        {/*COUNTRIES */}
        {currentUser.user.type ==="ADMIN" ?
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Countries"> 
        <FlagOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.Countries}</span>
          <Link to="/Countries"></Link>
        </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('COUNTRIES')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Countries"> 
        <FlagOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
          <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.Countries}</span>
          <Link to="/Countries"></Link>
        </Menu.Item>
        }
        
        
        
        
        

          <SubMenu key="sub3" style={{paddingLeft:isRTL?collapsed?0:35:0}} icon={<ControlOutlined style={{
             float:isRTL? 'right':'none',
             position:isRTL?'absolute':'relative',
             right:isRTL?collapsed?28:16:collapsed?4:'auto'
            }}  />} title={allStrings.setting}>
            {/*ABOUT */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/about"> 
            <InfoCircleOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.about}</span>
              <Link to="/about"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('ABOUT')&&
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/about"> 
              <InfoCircleOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                  <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.about}</span>
                <Link to="/about"></Link>
            </Menu.Item>
            }

            {/*SETTINGS */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Setting"> 
            <ControlOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}} />
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.setting}</span>
              <Link to="/Setting"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('SETTINGS')&&
            <Menu.Item style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Setting"> 
              <ControlOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}} />
                  <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.setting}</span>
                <Link to="/Setting"></Link>
            </Menu.Item>
            }
            
            {/*problemTypes */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/problemTypes"> 
            <ExclamationCircleOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.problemTypes}</span>
              <Link to="/problemTypes"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('ABOUT')&&
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/problemTypes"> 
              <ExclamationCircleOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                  <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.problemTypes}</span>
                <Link to="/problemTypes"></Link>
            </Menu.Item>
            }
            {/*PERMISSIONS */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Permissions"> 
            <LockOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.permissions}</span>
              <Link to="/Permissions"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('PERMISSIONS')&&
            <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start',paddingRight:isRTL?collapsed?'20px':'40px':0,paddingLeft:isRTL?'0px':collapsed?'14px':'48px',width:'190px'}} key="/Permissions"> 
              <LockOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}}/>
                  <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.permissions}</span>
                <Link to="/Permissions"></Link>
              </Menu.Item>
            }
            {/*social */}
            {currentUser.user.type ==="ADMIN" ?
            <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Social"> 
              <ApartmentOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
              <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.social}</span>
              <Link to="/Social"></Link>
            </Menu.Item>
            :
            currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('SOCIAL')&&
            <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Social"> 
            <ApartmentOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
              <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.social}</span>
              <Link to="/Social"></Link>
            </Menu.Item>
          }
         
            
          </SubMenu>
          {/*problems */}
          {currentUser.user.type ==="ADMIN" ?
          <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/problems"> 
          <ExclamationCircleOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
            <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.problems}</span>
            <Link to="/problems"></Link>
          </Menu.Item>
          :
          currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('PROBLEMS')&&
          <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/problems"> 
          <ExclamationCircleOutlined  style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
            <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.problems}</span>
            <Link to="/problems"></Link>
          </Menu.Item>
          }
          
          {/*terms */}
          {currentUser.user.type ==="ADMIN" ?
          <Menu.Item  style={{textAlign:isRTL?'end': 'start'}} key="/Terms"> 
          <SafetyOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}} />
              <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.Terms}</span>
            <Link to="/Terms"></Link>
          </Menu.Item>
          :
          currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('TERMS')&&
          <Menu.Item  style={{textAlign:isRTL?collapsed?'end': 'start':'start'}} key="/Terms"> 
          <SafetyOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?13:12:collapsed?'-2px':'-3px'}} />
              <span className="menuTitle"  style={{marginRight:isRTL? '6px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.Terms}</span>
            <Link to="/Terms"></Link>
          </Menu.Item>
          }
        {/*FAQ */}
        {currentUser.user.type ==="ADMIN" ?
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Questions"> 
        <QuestionCircleOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
            <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.questions}</span>
          <Link to="/Questions"></Link>
        </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('FAQ')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/Questions"> 
        <QuestionCircleOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
            <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.questions}</span>
          <Link to="/Questions"></Link>
        </Menu.Item>
        }
        {/*NOTIFS */}
        {currentUser.user.type ==="ADMIN" ?
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/SendNotifs"> 
        <NotificationOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
            <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.sendNotif}</span>
          <Link to="/SendNotifs"></Link>
        </Menu.Item>
        :
        currentUser.user.type ==="SUB-ADMIN" && currentUser.user.permission.pages.includes('NOTIFS')&&
        <Menu.Item  style={{textAlign:isRTL? 'end':'start'}} key="/SendNotifs"> 
        <NotificationOutlined style={{position:isRTL?'relative':'relative',float:isRTL? 'right':'none',top:isRTL?collapsed?4:12:collapsed?'-2px':'-3px'}}/>
            <span className="menuTitle"  style={{marginRight:isRTL? '10px':'0px',marginLeft:isRTL?'0px':'10px',float:isRTL?'right':'none'}}>{allStrings.sendNotif}</span>
          <Link to="/SendNotifs"></Link>
        </Menu.Item>
        }
        
        
        
        <Menu.Item></Menu.Item>
        <Menu.Item></Menu.Item>
        <Menu.Item></Menu.Item>
        
        
      </Menu>
      
    </Sider>
  );
};
const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
  menu: state.menu.menu,
})

const mapDispatchToProps = {
  setUser,
  ChangeLanguage,
  Collapsed
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(SiderMenu)
);


